import { ReactElement, ReactNode } from 'react';
import { useSettingsPageContent } from '../../state/SettingsPage/useSettingsPageContent';

export interface SettingsPageContentProps {
  /**
   * <SettingsPage.MainContent> and, if needed, <Settings.AdditionalContent> elements
   */
  children: ReactNode;
}

export type SettingsPageContentElement = ReactElement<
  SettingsPageContentProps,
  typeof SettingsPageContent
>;

export function SettingsPageContent(_props: SettingsPageContentProps) {
  return null;
}

SettingsPageContent.useSettingsPageContent = useSettingsPageContent;
SettingsPageContent.displayName = 'SettingsPageContent';
